import { FORM_IDS, FORM_PORTAL_ID } from 'constants/form';

// Building types
export const BUILDING_TYPES = [
  { value: 'apartment', label: 'Apartment' },
  { value: 'condo', label: 'Condo' },
  { value: 'office', label: 'Office' },
  { value: 'commercial-single', label: 'Commercial (single-tenant)' },
  { value: 'commercial-multi', label: 'Commercial (multi-tenant)' },
  { value: 'school', label: 'School' },
  { value: 'other', label: 'Other' },
];

export const HUBSPOT_FORM_ID = FORM_IDS.ESTIMATE_GENERATOR;
export const HUBSPOT_ACCOUNT_ID = FORM_PORTAL_ID;
export const HUBSPOT_FORM_URL = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_ACCOUNT_ID}/${HUBSPOT_FORM_ID}`;

export default {
  BUILDING_TYPES,
  HUBSPOT_FORM_ID,
  HUBSPOT_ACCOUNT_ID,
};
